import React from "react";
import { Grid } from "@mui/material";
import { Icon } from "@iconify/react";
import { MobileCard } from "@ui/components/card";
import { SButton } from "@ui/components/buttons/SButton";
import { IconText } from "@ui/components/info/IconText";
import { useTranslation } from "react-i18next";
export const DailyReportCard = ({ row, downloading, onDownload, }) => {
    const { t } = useTranslation(["common"]);
    const periodLabel = `${new Date(row.periodStart).toLocaleDateString()} – ${new Date(row.periodEnd).toLocaleDateString()}`;
    return (React.createElement(MobileCard, null,
        React.createElement(Grid, { container: true, spacing: 2 },
            React.createElement(Grid, { size: 6 },
                React.createElement(IconText, { icon: "solar:calendar-linear", text: new Date(row.date).toLocaleDateString() })),
            React.createElement(Grid, { size: 6 },
                React.createElement(IconText, { icon: "solar:bell-linear", text: String(row.alarmCount) }))),
        React.createElement(Grid, { container: true, spacing: 2 },
            React.createElement(Grid, { size: 12 },
                React.createElement(IconText, { icon: "solar:clock-circle-linear", text: periodLabel }))),
        React.createElement(SButton, { variant: "soft", fullWidth: true, size: "small", startIcon: React.createElement(Icon, { icon: "line-md:cloud-down" }), disabled: downloading, onClick: () => onDownload(row.id) }, t("common:actions.downloadDayReport"))));
};
